import { render, staticRenderFns } from "./GoogleTranslateLink.vue?vue&type=template&id=101c8b34&"
import script from "./GoogleTranslateLink.vue?vue&type=script&lang=js&"
export * from "./GoogleTranslateLink.vue?vue&type=script&lang=js&"
import style0 from "./GoogleTranslateLink.vue?vue&type=style&index=0&id=101c8b34&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports